module.exports = __webpack_public_path__ + "img/dashboardv2.6e27c393.png";